// Atlas share-URL parsing (ATL-8). `?atlas=lat,lon[,scale]` boots directly into an
// Atlas world at those coordinates (skips geocoding); a bare `?atlas` (or a
// malformed value) resolves to the offline KHFD default (ATL-6). Pure — no DOM — so
// it unit-tests without a browser.

/** Parsed coordinates for `?atlas=…`. No `lat` ⇒ the default location. */
export interface AtlasDeepLink {
  lat?: number;
  lon?: number;
  scale: number;
}

/**
 * Parse the value of `?atlas=` into a location request. Accepts `lat,lon` and an
 * optional third `scale` (meters/block); negatives and decimals are honoured.
 * Anything not a valid lat,lon pair (empty, one number, non-numeric) → the default
 * KHFD location at scale 1.
 */
export function parseAtlasParam(val: string | null | undefined): AtlasDeepLink {
  // An empty component (`Number('')` is 0, not NaN) must count as malformed.
  const parts = val ? val.split(',').map((s) => (s.trim() === '' ? NaN : Number(s.trim()))) : [];
  const [lat, lon, scale] = parts;
  if (parts.length >= 2 && Number.isFinite(lat) && Number.isFinite(lon)) {
    return { lat, lon, scale: parts.length >= 3 && Number.isFinite(scale) && scale! > 0 ? scale! : 1 };
  }
  return { scale: 1 };
}
